import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

var ErrorMsg = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ErrorMsg",
  componentId: "sc-5pv5vu-0"
})(["color:", ";font-family:", ";font-size:", ";line-height:", ";font-weight:400;margin:0;margin-top:0.5em;text-align:left;a{color:", ";font-weight:bold;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.utilityColors.error;
}, typography.fontFamily, typography.fontSize, typography.lineHeight, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.utilityColors.error;
});
process.env.NODE_ENV !== "production" ? ErrorMsg.displayName = 'ErrorMsg' : void 0;

export { ErrorMsg, ErrorMsg as default };
